const popupsStore = {
  namespaced: true,
  state: {
    popUpVisible: false,
    popUpName: null,
    lastPopUpName: null,
    popUpData: null,
    footerVisible: false,
    disableScroll: false,
  },
  mutations: {
    setShowPopup(state, data) {
      if (state.popUpName) {
        state.lastPopUpName = state.popUpName
      }
      if (typeof data === 'object') {
        state.popUpName = data.name
        state.popUpData = data.data
      } else {
        state.popUpName = data
      }
      state.popUpVisible = true
    },
    setHidePopup(state) {
      state.lastPopUpName = null
      state.popUpName = null
      state.popUpData = null
      state.popUpVisible = false
    },
    setDisableScroll(state, value) {
      state.disableScroll = value
    },
  },
}

export default popupsStore
